var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenPopUp = function SvgOpenPopUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 1H7a1 1 0 0 0-1 1v4H2a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1v-4h4a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1Zm-5 21H2V7h4v10a1 1 0 0 0 1 1h10v4Zm5-4.5V17H7V2h15v15.5Z",
    fill: "#767676"
  })));
};
export default SvgOpenPopUp;